export function PrivacyPage() {
  return (
    <div className="py-12 bg-cacao-dark">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-xl font-semibold text-[#F5F5F5]">Privacy Policy</h1>
        <p className="mt-1.5 text-xs text-cacao-text-tertiary">Last updated: March 2, 2026</p>

        <div className="mt-8 space-y-6 text-sm text-cacao-muted leading-relaxed">
          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">1. Information We Collect</h2>

            <h3 className="mt-3 text-xs font-medium text-cacao-muted">Information You Provide</h3>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Account information (name, email, password)</li>
              <li>Profile information (company, role, LinkedIn URL)</li>
              <li>ICP preferences and outreach settings</li>
              <li>Contact lists you upload</li>
            </ul>

            <h3 className="mt-3 text-xs font-medium text-cacao-muted">Information We Collect Automatically</h3>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Usage data (features used, emails sent, leads viewed)</li>
              <li>Device information (browser type, IP address)</li>
              <li>Log data (access times, pages viewed)</li>
            </ul>

            <h3 className="mt-3 text-xs font-medium text-cacao-muted">Third-Party Data</h3>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Lead data from Apollo.io and other enrichment providers</li>
              <li>Professional data from LinkedIn (via OAuth)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">2. How We Use Information</h2>
            <p className="mt-2">We use your information to:</p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Provide and improve the Service</li>
              <li>Generate leads matching your ICP</li>
              <li>Draft personalized email content</li>
              <li>Send service communications</li>
              <li>Analyze usage and improve features</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">3. Information Sharing</h2>
            <p className="mt-2">We do not sell your personal information. We may share information with:</p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Service providers (hosting, analytics, email delivery)</li>
              <li>Third-party APIs (Apollo.io, LinkedIn) as necessary for the Service</li>
              <li>Legal authorities when required by law</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">4. Data Security</h2>
            <p className="mt-2">
              We implement industry-standard security measures including encryption in transit and at rest, Row Level Security (RLS), and regular security audits.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">5. Data Retention</h2>
            <p className="mt-2">
              We retain your data for as long as your account is active. You may request deletion of your account and data at any time by contacting support.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">6. Your Rights</h2>
            <p className="mt-2">Depending on your location, you may have rights to:</p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Delete your data</li>
              <li>Export your data</li>
              <li>Opt out of marketing communications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">7. Cookies</h2>
            <p className="mt-2">
              We use cookies and similar technologies to maintain sessions, remember preferences, and analyze usage. You can control cookies through your browser settings.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">8. Children's Privacy</h2>
            <p className="mt-2">
              The Service is not intended for users under 18. We do not knowingly collect information from children.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">9. International Transfers</h2>
            <p className="mt-2">
              Your data may be processed in the United States. By using the Service, you consent to this transfer.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">10. Changes to This Policy</h2>
            <p className="mt-2">
              We may update this Privacy Policy. We will notify you of material changes via email or through the Service.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">11. Contact Us</h2>
            <p className="mt-2">
              For privacy-related questions, contact us at{' '}
              <a href="mailto:privacy@tractionbee.com" className="text-cacao-gold hover:text-cacao-gold-hover transition-colors">privacy@tractionbee.com</a>.
            </p>

            <p className="mt-6 text-xs text-cacao-text-tertiary">
              <strong className="text-cacao-muted">Traction Bee</strong><br />
              26565 Agoura Road, Suite 200<br />
              Calabasas, CA 91302 USA
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
